import { render, staticRenderFns } from "./ProductCodeMngt.vue?vue&type=template&id=5b89f29c"
import script from "./ProductCodeMngt.vue?vue&type=script&lang=js"
export * from "./ProductCodeMngt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports